module.exports = __webpack_public_path__ + "static/media/300_12.bade970b.jpg";